import React, { useState, useEffect } from 'react';
import {
  Button,
  Label,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from 'reactstrap';

/**
 * Modal to create or edit a FAQ
 */
function FAQModal({
  title = 'Pregunta Frecuente',
  isOpen = false,
  onToggle = () => {},
  defaultValue = null,
  onSubmit = () => {},
}) {
  const [categoria, setCategoria] = useState('Compra');
  const [pregunta, setPregunta] = useState('');
  const [respuesta, setRespuesta] = useState('');

  // Update fields when defaultValue changes (for edit mode)
  useEffect(() => {
    if (defaultValue) {
      setCategoria(defaultValue.categoria || 'Compra');
      setPregunta(defaultValue.pregunta || '');
      setRespuesta(defaultValue.respuesta || '');
    } else {
      // Reset form for create mode
      setCategoria('Compra');
      setPregunta('');
      setRespuesta('');
    }
  }, [defaultValue, isOpen]);

  const handleSubmit = () => {
    if (!categoria.trim() || !pregunta.trim() || !respuesta.trim()) {
      return;
    }

    onSubmit(categoria.trim(), pregunta.trim(), respuesta.trim());
  };

  const handleCancel = () => {
    // Reset to original values
    if (defaultValue) {
      setCategoria(defaultValue.categoria || 'Compra');
      setPregunta(defaultValue.pregunta || '');
      setRespuesta(defaultValue.respuesta || '');
    } else {
      setCategoria('Compra');
      setPregunta('');
      setRespuesta('');
    }
    onToggle(); // Close modal
  };

  return (
    <Modal isOpen={isOpen} fade={false} toggle={onToggle} size="lg">
      <ModalHeader toggle={onToggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label htmlFor="categoria">Categoría *</Label>
          <Input
            id="categoria"
            type="select"
            value={categoria}
            onChange={(e) => setCategoria(e.target.value)}
          >
            <option value="Compra">Compra</option>
            <option value="Venta">Venta</option>
          </Input>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="pregunta">Pregunta *</Label>
          <Input
            id="pregunta"
            type="textarea"
            rows="3"
            value={pregunta}
            onChange={(e) => setPregunta(e.target.value)}
            placeholder="Ej: ¿Cuáles son los métodos de pago disponibles?"
          />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="respuesta">Respuesta *</Label>
          <Input
            id="respuesta"
            type="textarea"
            rows="5"
            value={respuesta}
            onChange={(e) => setRespuesta(e.target.value)}
            placeholder="Ej: Aceptamos efectivo, transferencia bancaria y tarjetas de crédito."
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={handleSubmit}>
          Guardar
        </Button>
        <Button color="secondary" onClick={handleCancel}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default FAQModal;
